module.exports = __webpack_public_path__ + "images/parachute.ab9446b8.svg";